/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Table, Button, Space, Input, message, Modal, Tooltip, Spin } from "antd"; // Added Spin
import { IdcardOutlined } from "@ant-design/icons";
import axios from "axios";

const { Search } = Input;

const Customers = () => {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState("");
  const [loading, setLoading] = useState(false); // Loader state
  const authData = localStorage.getItem("auth");
  const authObject = JSON.parse(authData);

  const token = authObject?.accessToken;

  // Fetch customers and set action as status
  const fetchCustomers = async () => {
    setLoading(true); // Start loader
    try {
      const response = await axios.get(
        `${API_BASE}/user/getAllUsers`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Filter only users with role 'provider'
      const usersWithStatus = response.data.data.filterUser
        .filter((user) => user.role === "user")
        .map((user) => ({
          ...user,
        }));

      setCustomers(usersWithStatus);
      setFilteredCustomers(usersWithStatus);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
    setLoading(false); // Stop loader
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  // Function to handle block/unblock action
  const handleBlockUnblock = async (id) => {
    setLoading(true); // Start loader
    try {
      const response = await axios.put(
        `${API_BASE}/user/updateUserAction/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      message.success("Action updated successfully");

      const newAction = response.data.data.action; // Get updated action status

      // Update customers data with new action
      const updatedCustomers = customers.map((customer) => {
        if (customer._id === id) {
          return { ...customer, action: newAction };
        }
        return customer;
      });

      setCustomers(updatedCustomers);
      setFilteredCustomers(updatedCustomers); // Update filtered data as well
    } catch (error) {
      console.error("Error updating customer status:", error);
    }
    setLoading(false); // Stop loader
  };

  // Handle search input change
  const onSearch = (value) => {
    setSearchText(value);
    const filtered = customers.filter((item) =>
      Object.values(item).some((val) =>
        String(val).toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredCustomers(filtered);
  };

  const highlightText = (text) => {
    if (!text) return ""; // Return an empty string if text is undefined or null
    if (!searchText) return text; // Return the original text if there is no search text

    const regex = new RegExp(`(${searchText})`, "gi");
    const parts = text.toString().split(regex); // Convert text to a string before splitting

    return parts.map((part, index) =>
      part.toLowerCase() === searchText.toLowerCase() ? (
        <span
          key={index}
          style={{ backgroundColor: "yellow", fontWeight: "bold" }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  const columns = [
    {
      title: "ID",
      key: "idIcon",
      render: (text, record) => (
        <Tooltip title="Show User ID">
          <Button
            type="link"
            icon={<IdcardOutlined />}
            onClick={() => {
              setSelectedUserId(record._id);
              setModalVisible(true);
            }}
            style={{ fontSize: "18px" }}
          />
        </Tooltip>
      ),
    },
    {
      title: "Name",
      key: "name",
      render: (text, record) => (
        <span>{highlightText(`${record.firstName} ${record.lastName}`)}</span>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      render: (text) => <span>{highlightText(text)}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (text) => <span>{highlightText(text)}</span>,
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (text) => <span>{highlightText(text)}</span>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="link"
            style={{
              backgroundColor: record.action ? "#52c41a" : "#FF0000",
              color: "#fff",
              borderRadius: "4px",
              padding: "4px 8px",
              fontWeight: "bold",
            }}
            onClick={() => handleBlockUnblock(record._id)}
          >
            {record.action ? "UnBlock" : "Block"}
          </Button>
        </Space>
      ),
    },
  ];
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <div className="bg-gray-100 min-h-screen p-4">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h2 className="text-lg font-semibold mb-4">Users</h2>
        <Search
          placeholder="Search users"
          enterButton
          value={searchText}
          onChange={(e) => onSearch(e.target.value)}
          className="mb-4"
        />
        <Spin spinning={loading}>
          <div
            style={{
              maxHeight: "500px",
              overflowX: "scroll",
              overflowY: "scroll",
            }}
          >
            <Table
              dataSource={filteredCustomers}
              columns={columns}
              rowKey="_id"
              pagination={{ pageSize: 10 }}
              scroll={{ x: "max-content", y: 500 }}
              sticky
            />
          </div>
        </Spin>
        <Modal
          title="User ID"
          visible={modalVisible}
          onOk={() => setModalVisible(false)}
          onCancel={() => setModalVisible(false)}
          footer={[
            <Button
              key="ok"
              type="primary"
              onClick={() => setModalVisible(false)}
            >
              OK
            </Button>,
          ]}
        >
          <div style={{ wordBreak: "break-all" }}>{selectedUserId}</div>
        </Modal>
      </div>
    </div>
  );
};

export default Customers;